import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { ClipLoader } from 'react-spinners';
import Navbar from '../components/navbar';
import Footer from '../components/footer';

const OrderReceivedPage = () => {
    const { orderNumber } = useParams();
    const [orderDetails, setOrderDetails] = useState(null);
    const [loading, setLoading] = useState(true);
    const [cartCount, setCartCount] = useState(0);

    useEffect(() => {
        const fetchOrderDetails = async () => {
            try {
                const response = await axios.get(
                    `https://afric-fresh-backend.onrender.com/order/${orderNumber}`
                );
                setOrderDetails(response.data);
            } catch (error) {
                console.error('Error fetching order details:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchOrderDetails();
    }, [orderNumber]);

    const updateCartCount = () => {
        const storedCartItems = JSON.parse(localStorage.getItem('cartItems')) || [];
        setCartCount(storedCartItems.reduce((acc, item) => acc + item.quantity, 0));
    };

    if (loading) {
        return (
            <div className="flex justify-center items-center min-h-screen">
                <ClipLoader color="#007D44" loading={loading} size={50} />
            </div>
        );
    }

    if (!orderDetails) {
        return (
            <div className="flex justify-center items-center min-h-screen">
                <p className="text-xl text-red-500">Order not found.</p>
            </div>
        );
    }

    return (
        <>
            <Navbar cartCount={cartCount} updateCartCount={updateCartCount} />
            <div className="container mx-auto p-4 lg:p-6 lg:mt-[70px] mt-[130px] max-w-7xl">
                <div className="bg-gradient-to-r from-green-50 to-green-100 rounded-lg border-2 border-[#007D44] p-6 mb-8 text-center transform hover:scale-[1.02] transition-transform duration-300">
                    <div className="flex items-center justify-center mb-4">
                        <svg className="w-12 h-12 text-[#007D44]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                    </div>
                    <h2 className="text-3xl font-bold text-[#007D44]">Thank You!</h2>
                    <p className="text-gray-600 mt-2">Your order has been received and is being processed.</p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
                    {[
                        { label: "Order Number", value: orderDetails.orderNumber },
                        { label: "Date", value: new Date(orderDetails.date).toLocaleDateString() },
                        { label: "Item Total", value: `$${orderDetails.subtotal}` },
                        { label: "Deelivery Fee", value: `$${orderDetails.shippingCost}` },
                        { label: "Total", value: `$${orderDetails.total}` },
                        { label: "Payment Method", value: orderDetails.paymentMethod },
                        { label: "Delivery", value: orderDetails.deliveryTime }
                    ].map((item, index) => (
                        <div key={index} className="bg-white rounded-lg shadow-lg p-4 hover:shadow-xl transition-shadow duration-300">
                            <p className="text-gray-600 text-sm">{item.label}</p>
                            <p className="font-bold text-lg text-[#007D44]">{item.value}</p>
                        </div>
                    ))}
                </div>

                <div className="bg-white rounded-lg shadow-lg p-6 mb-8">
                    <h3 className="text-2xl font-bold mb-4 text-[#007D44]">Order Details</h3>
                    <div className="overflow-x-auto">
                        <table className="w-full">
                            <thead className="bg-gray-50">
                                <tr>
                                    <th className="px-4 py-3 text-left text-gray-700">Product</th>
                                    <th className="px-4 py-3 text-right text-gray-700">Total</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-200">
                            {orderDetails.cartItems.map((item) => (
                                    <tr key={item.id} className="hover:bg-gray-50">
                                        <td className="px-4 py-3">{item.name} × {item.quantity}</td>
                                        {item.orderType !== "Large Box" && item.orderType !== "Small Box" && (
                                            <td className="px-4 py-3 text-right">
                                                ${(parseFloat(item.price.replace('$', '')) * item.quantity).toFixed(2)}
                                            </td>
                                        )}
                                    </tr>
                                ))}
                                <tr className="bg-gray-50">
                                    <td className="px-4 py-3 font-semibold">Shipping</td>
                                    <td className="px-4 py-3 text-right">{orderDetails.shippingMethod}</td>
                                </tr>
                                <tr className="bg-gray-50">
                                    <td className="px-4 py-3 font-semibold">Delivery </td>
                                    <td className="px-4 py-3 text-right">{orderDetails.deliveryTime}</td>
                                </tr>
                                <tr className="bg-gray-50">
                                    <td className="px-4 py-3 font-semibold">Payment Method</td>
                                    <td className="px-4 py-3 text-right">{orderDetails.paymentMethod}</td>
                                </tr>
                                <tr className="bg-[#007D44] text-white">
                                    <td className="px-4 py-3 font-bold">Items Total</td>
                                    <td className="px-4 py-3 text-right font-bold">${orderDetails.subtotal}</td>
                                </tr>
                                <tr className="bg-[#007D44] text-white">
                                    <td className="px-4 py-3 font-bold">Delivery Fee</td>
                                    <td className="px-4 py-3 text-right font-bold">${orderDetails.shippingCost}</td>
                                </tr>
                                <tr className="bg-[#007D44] text-white">
                                    <td className="px-4 py-3 font-bold">Total</td>
                                    <td className="px-4 py-3 text-right font-bold">${orderDetails.total}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="grid md:grid-cols-2 gap-8">
                    <div className="bg-white rounded-lg shadow-lg p-6">
                        <h3 className="text-2xl font-bold mb-4 text-[#007D44]">Billing Address</h3>
                        <div className="space-y-2 text-gray-700">
                            <p className="font-semibold">{`${orderDetails.billingAddress.firstName} ${orderDetails.billingAddress.lastName}`}</p>
                            <p>{orderDetails.billingAddress.streetAddress}</p>
                            {orderDetails.billingAddress.apartment && <p>{orderDetails.billingAddress.apartment}</p>}
                            <p>{`${orderDetails.billingAddress.city}, ${orderDetails.billingAddress.state} ${orderDetails.billingAddress.zipCode}`}</p>
                            <p>{orderDetails.billingAddress.country}</p>
                            <p className="mt-4">📱 {orderDetails.billingAddress.phone}</p>
                            <p>📧 {orderDetails.billingAddress.email}</p>
                        </div>
                    </div>

                    <div className="bg-white rounded-lg shadow-lg p-6">
                        <h3 className="text-2xl font-bold mb-4 text-[#007D44]">Shipping Address</h3>
                        <div className="space-y-2 text-gray-700">
                            <p className="font-semibold">{`${orderDetails.billingAddress.firstName} ${orderDetails.billingAddress.lastName}`}</p>
                            <p>{orderDetails.billingAddress.streetAddress}</p>
                            {orderDetails.billingAddress.apartment && <p>{orderDetails.billingAddress.apartment}</p>}
                            <p>{orderDetails.billingAddress.city}</p>
                            <p>{orderDetails.billingAddress.state}</p>
                            <p>{orderDetails.billingAddress.zipCode}</p>
                            <p>{orderDetails.billingAddress.country}</p>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default OrderReceivedPage;